module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-SemiBold.78da704.woff2";